<template>
	<v-dialog
		v-model="dialog"
		scrollable
		:width="$vuetify.breakpoint.lgAndUp? '40%':'auto'"
		transition="dialog-bottom-transition"
		:persistent="isloading"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="success"
				dark
				bottom
				right
				tile
				:disabled="isloading"
				v-on="on"
			>
				<v-icon :left="$vuetify.breakpoint.lgAndUp">person_add</v-icon>
				{{$vuetify.breakpoint.lgAndUp? 'Agregar Usuario':''}}
			</v-btn>
		</template>
		<v-form v-model="validForm" @submit.prevent="onCreateNewUserEvt">
		<v-card :loading="isloading">
			<!-- <v-card-title class="ma-0"> -->
			<v-toolbar dark color="primary">
				<v-btn icon dark @click="dialog = false">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>
					Formulario Usuario
				</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<!-- </v-card-title> -->
			<v-card-text>
				<v-row>
					<v-col md="12" cols="12" lg="6">
						<v-text-field
							name="name"
							type="text"
							v-model="userData.nombre"
							:rules="[validarUsuario]" 
							label="Nombre"
							outlined rounded
						/>
					</v-col>
					<v-col md="12" cols="12" lg="6">
						<v-text-field
							name="rut"
							type="text"
							v-model="userData.rut"
							:rules="validarRut" 
							label="RUT"
							outlined rounded
							v-rut-mask
						/>
					</v-col>
				</v-row>
			<!-- 				<v-row>
					<v-col>
						<v-text-field
							name="username"
							type="text"
							v-model="userData.usuario"
							label="Nombre de Usuario"
							outlined rounded
						/>
					</v-col>
					<v-col>
						<v-text-field
							name="email"
							type="text"
							v-model="userData.email"
							label="Email"
							outlined rounded
						/>
					</v-col>
				</v-row> -->
			<v-container>
				<v-row>
					<v-col lg="12">
						<v-subheader>Permisos</v-subheader>
						<v-divider class="mt-0 mb-3"/>
					<!-- </v-col> -->
					<!-- <v-col> -->
						<v-data-table
							:headers="headers"
							:items="permisos"
							loading-text="Cargando permisos"
							no-data-text="No hemos encontrado datos..."
							locale="es"
							hide-default-footer
							class="elevation-1"
							dense
						>
							<template v-slot:item.permitido="{item}">
								<v-row align="center" dense>
									<v-spacer/>
									<v-checkbox
										v-model="permisosUsuario"
										:value="item"
										:disabled="item.codigo == permisoBoleta.codigo"
										 hide-details
										class="my-1"
									>
									</v-checkbox>
									<v-spacer/>
								</v-row>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-container>
			</v-card-text>
			<!-- <v-divider></v-divider> -->
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer/>
				<v-btn 
					color="success"
					:disabled="!validForm"
					:loading="isloading"
					@click="onCreateNewUserEvt"
				>
					<v-icon left>{{!!user?'add':'edit'}}</v-icon>
					Agregar Usuario
				</v-btn>
			</v-card-actions>
		</v-card>
		</v-form>
		<v-snackbar
			v-model="alerta.display"
			:color="alerta.type"
		>
			{{ alerta.msg }}
		</v-snackbar>
	</v-dialog>
</template>

<script>

import ApiManager from '@/views/GestionUsuarios/ApiManager';
import { rutValidate } from 'rut-helpers';

let apiUser = new ApiManager('apiBoletaSII');

export default {
	name: 'UserForm',
	props: {
		user: {
			type: Object,
			default: ()=>{return null}
		},
		permisos: {
			type: Array,
			default: ()=>{return [];}
		}
	},
	computed: {
		headers () {
			return [
				{
					text: 'Sección',
					value: 'nombre',
					sortable: false
				},
				{
					text: 'Permitido',
					value: 'permitido',
					align: 'center',
					sortable: false
				},
			];
		},
		validarRut(){
			return [
				v=>!!v || 'Introduzca un rut',
				v=>rutValidate(v) || 'Ingrese un rut válido'
			];
		},
		permisoBoleta(){
			let out = null;
			let permisos = this.permisos || [];
			for( let permiso of permisos ){
				if( permiso.codigo == 'boleta' )	out = permiso;
			}

			if(!!out)	this.permisosUsuario.push(out);

			return out;
		}
	},
	data () {
		return {
			dialog: false,
			userData:{
				rut:undefined,
				dv:'',
				nombre: '',
				usuario: '',
				permisos:[],
				empresas:[]
			},
			validForm:false,
			isloading: false,
			alerta:{
				display: false,
				msg: '',
				type: 'success'
			},
			permisosUsuario:[]
		}
	},
	methods: {
		async onCreateNewUserEvt () {
			// /gestor-edit-user

			let vm = this;

			if( !vm.userData.rut ) return;
			if( !vm.$store.getters['empresas/seleccionada'].rut ) return;

			let usuario = {
				user: vm.userData.rut.replace(/\./g, ''),
				nombre: vm.userData.nombre,
				permisos: vm.permisosUsuario
			};
			

			let contribuyente = vm.$store.getters['empresas/seleccionada'].rut;
			// contribuyente = contribuyente.replace(/\./g, '');

			try{
				vm.isloading = true;
				let resp = await apiUser.post('/gestor-edit-user', {
					contribuyente,
					usuario
				});

				let userResp = resp.result;
				let relResp = resp.resConUser;

				let msg = '';
				let type = '';

				if( !!relResp.statusCode ){

					switch( relResp.statusCode ){
						case 'USR_R':
							msg = relResp.message;
							type = 'warning';
						break;
						default:
							msg = relResp.message;
							type = 'error';
					}

				}else if(!!userResp.statusCode ){

					switch( userResp.statusCode ){
						case 'USR_R':
							msg = relResp.message;
							type = 'warning';
						break;
						case 'USR_E':
							msg = `Se le ha otorgado el acceso al usuario ${usuario.user}.`;
							type = 'success';
						break;
						default:
							msg = relResp.message;
							type = 'error';
					}
				}else if( !!resp.error )
					throw resp.error;
				else{
					msg = 'Se ha creado el usuario '+usuario.user;
					type = 'success';
				}

				vm.onFinish(type, msg);
			}catch(err){
				if( err.constructor.name !== 'Cancel' )
					vm.showAlert('error', err);
			}

			vm.isloading = false;
		},
		onFinish: function(type, msg){
			this.isloading = false;
			this.$emit('on-success', {type, msg});
			this.dialog = false;
		},
		showAlert: function(type, msg){
			this.alerta.display = true;
			this.alerta.type = type;
			this.alerta.msg = msg;
		},
		loadEditedUserData(){

			Object.assign(this.userData, this.user);
		},
		validarUsuario: function(v) {
			return ((v !== undefined) && (v!== '') ) || 'Introduzca un usuario';
		},
	},
	watch:{
		dialog(val){
			if( !!this.permisoBoleta ) this.permisosUsuario.push(this.permisoBoleta);
			if(val){
				if( !!this.user )	this.loadEditedUserData();
			}
		}
	}
}
</script>

<style lang="css" scoped>
</style>